import { render, staticRenderFns } from "./BulkProductGridItem.vue?vue&type=template&id=e1983e34&"
import script from "./BulkProductGridItem.vue?vue&type=script&lang=js&"
export * from "./BulkProductGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports